import * as React from "react"
import {useEffect} from "react"
import {Box} from "@mui/material";

import {RAW_MATCHER_ROUTES} from "@constants";
import PageWrapper from "../../@PageWrapper";
import {MatchersSkeleton} from "../@components";
import {useRawMatcherItems} from "./@hooks";
import {clearRawMatcherSignals, isRawMatcherLoading} from "./@signals";
import RawMatcherContent from "./Content";
import CreateSkuDrawer from "../skus/DrawerSku";


export default function RawMatcherPage() {
	const { handleSubmit } = useRawMatcherItems()

	useEffect(() => {
		const params = new URLSearchParams(window.location.search)
		const idMapping = params.get('id_mapping')
		const productId = params.get('product_id')
		const idSite = params.get('id_site')

		if (productId && idSite) {
			handleSubmit({ product_id: productId, id_site: idSite })
		} else {
			handleSubmit(idMapping)
		}
		return clearRawMatcherSignals
	}, [])

	const hasDirectLookup = (() => {
		const params = new URLSearchParams(window.location.search)
		return params.get('id_mapping') !== null || (params.get('product_id') !== null && params.get('id_site') !== null)
	})()

	return <PageWrapper head={`Product to SKU | ${RAW_MATCHER_ROUTES.RAW_SUBTITLE}`} title={RAW_MATCHER_ROUTES.TITLE} subtitle={RAW_MATCHER_ROUTES.RAW_SUBTITLE}>
		<Box width={1} height={1} position="relative" top={20}>
			{ isRawMatcherLoading.value
				? <MatchersSkeleton />
				: <RawMatcherContent hasIdMapping={hasDirectLookup} />
			}
		</Box>

		<CreateSkuDrawer />
	</PageWrapper>
}